module.exports = __webpack_public_path__ + "media/images/logo/vac-7db5f6e2d1ecd928470ba040b932c297.jpg";